import React, { useState, useEffect } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useSettings } from '../context/SettingsContext';

const NetflixLoader = () => {
  const { settings, loading } = useSettings();
  const [showLoader, setShowLoader] = useState(true);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    // Attendre que les paramètres soient chargés
    if (!loading) {
      // Délai minimum de 1.5 secondes pour l'animation
      const timer = setTimeout(() => {
        setFadeOut(true);
        // Attendre la fin de l'animation de fade out avant de masquer
        setTimeout(() => {
          setShowLoader(false);
        }, 500);
      }, 1500);

      return () => clearTimeout(timer);
    }
  }, [loading]);

  if (!showLoader) return null;

  const siteName = !loading && settings?.site_name ? settings.site_name : 'Tchamba Marketplace';

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'white',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
        opacity: fadeOut ? 0 : 1,
        transition: 'opacity 0.5s ease-out',
      }}
    >
      {/* Logo/Titre animé */}
      <Box
        sx={{
          mb: 4,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
          animation: 'pulse 2s ease-in-out infinite',
          '@keyframes pulse': {
            '0%, 100%': {
              transform: 'scale(1)',
              opacity: 1,
            },
            '50%': {
              transform: 'scale(1.05)',
              opacity: 0.9,
            },
          },
        }}
      >
        {/* Logo du site */}
        {!loading && settings?.site_logo && (
          <Box
            // sx={{
            //   animation: 'fadeIn 0.8s ease-in',
            //   '@keyframes fadeIn': {
            //     '0%': {
            //       opacity: 0,
            //       transform: 'scale(0.8)',
            //     },
            //     '100%': {
            //       opacity: 1,
            //       transform: 'scale(1)',
            //     },
            //   },
            // }}
          >
            <Box
              component="img"
              src={settings.site_logo}
              alt="Logo"
              sx={{
                height: { xs: 60, sm: 80, md: 100 },
                width: 'auto',
                maxWidth: { xs: 120, sm: 160, md: 200 },
                objectFit: 'contain',
                borderRadius: '8px',
              }}
            />
          </Box>
        )}
        
        {/* Titre du site */}
        {/* <Typography
          variant="h3"
          sx={{
            fontWeight: 900,
            background: 'linear-gradient(90deg, #9b5de5 0%, #f15bb5 100%)',
            backgroundClip: 'text',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            fontSize: { xs: '1.5rem', sm: '2rem', md: '2.5rem' },
            letterSpacing: '0.1em',
            textAlign: 'center',
          }}
        >
          {siteName}
        </Typography> */}
      </Box>

      {/* Spinner de chargement */}
      <Box
        sx={{
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {/* <CircularProgress
          size={30}
          thickness={4}
          sx={{
            color: '#f15bb5',
            '& .MuiCircularProgress-circle': {
              strokeLinecap: 'round',
            },
          }}
        /> */}
        {/* Cercle externe animé */}
        <Box
          sx={{
            position: 'absolute',
            width: 20,
            height: 20,
            border: '0px solid rgba(241, 91, 181, 0.3)',
            borderRadius: '50%',
            animation: 'ripple 1.5s ease-out infinite',
            '@keyframes ripple': {
              '0%': {
                transform: 'scale(0.8)',
                opacity: 1,
              },
              '100%': {
                transform: 'scale(1.5)',
                opacity: 0,
              },
            },
          }}
        />
      </Box>

      {/* Barre de progression en bas */}
      <Box
        sx={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          height: 4,
          backgroundColor: 'rgba(255, 255, 255, 0.1)',
          overflow: 'hidden',
        }}
      >
        <Box
          sx={{
            height: '100%',
            width: '0%',
            backgroundColor: '#f15bb5',
            animation: 'loadingBar 2s ease-in-out infinite',
            '@keyframes loadingBar': {
              '0%': {
                width: '0%',
                left: '0%',
              },
              '50%': {
                width: '100%',
                left: '0%',
              },
              '100%': {
                width: '0%',
                left: '100%',
              },
            },
          }}
        />
      </Box>
    </Box>
  );
};

export default NetflixLoader;

